<template>
  <div class="">
    <el-form :model="delivery" label-position="left" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm" size="small" style="width: 100%">
      <el-form-item label="退款商品" prop="goods">
        <el-table
            :data="goodsList"
            border
            ref="rfTable"
            style="width: 100%"
            size="mini">
          <el-table-column
              prop="goods_name"
              label="商品">
          </el-table-column>
          <el-table-column
              prop="specs_name"
              label="规格"
              align="center">
            <template slot-scope="scope">
              {{scope.row.specs_name || '-'}}
            </template>
          </el-table-column>
          <el-table-column
              prop="quantity"
              label="下单数量"
              align="center"
              width="100">
          </el-table-column>
          <el-table-column
              prop="refund_quantity"
              label="已退款数量"
              align="center"
              width="100">
          </el-table-column>
          <el-table-column
              prop="can_refund_quantity"
              label="可退款数量"
              align="center"
              width="100">
          </el-table-column>
          <el-table-column
              prop="quantity"
              label="退款数量"
              align="center"
              width="130">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.remaining_quantity"
                :min="0"
                :max="scope.row.can_refund_quantity"
                :precision="0"
                :controls="false"
                :disabled="scope.row.can_refund_quantity <= 0"
                size="small"
                style="width: 100%">
              </el-input-number>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="退款备注" prop="remark">
        <el-input type="textarea" rows="3" v-model="delivery.remark" placeholder="请输入备注"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">确认退款</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      goodsList: [],
      delivery: {
        remark: '',
      },
      rules: {
      },
      orderInfo: {
        id: '',
        goods: []
      }
    }
  },
  components: {
  },
  props: {
    orderId: Number,
    callback: Function
  },
  watch: {
    'orderId': {
      handler (newValue, oldValue) {
        this.getOrderInfo(newValue)
      },
      deep: true,
      immediate: true
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    getOrderInfo(id) {
      this.showLoading()
      this.$api.order.orderDetail({id:id}, res => {
        this.hideLoading()
        if(res.errcode==0) {
          this.orderInfo = res.data
          this.goodsList = this.orderInfo.goods.map(item => {
            var canRefundQuantity = this.getCanRefundQuantity(item)
            return Object.assign({}, item, {
              can_refund_quantity: canRefundQuantity,
              remaining_quantity: 0
            })
          })
        }
      })
    },
    getCanRefundQuantity(item) {
      return Math.max(0, Number(item.quantity || 0) - Number(item.refund_quantity || 0))
    },
    submitForm() {
      var _this = this
      var params = this.delivery
      params.order_id = this.orderId
      params.goods = this.goodsList
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          _this.$api.order.orderRefund(params, res => {
            if (res.errcode == 0) {
              _this.success(res.errmsg)
              _this.callback()
            } else {
              _this.fail(res.errmsg)
            }
          })
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
</style>
